// components/indeed-cta/indeed-cta.react-component.tsx
import React from 'react';
import styles from './indeed-cta.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import {useI18n} from '@udemy-v2/i18n';
import {publishEvent} from '@udemy-v2/event-tracking';

import {LandingPageCTASelected} from '../events';
import {usePageContext} from '../../context/page-context';

const DEFAULT_INDEED_URL =
    'https://www.indeed.com/job-search-services/udemy?collectorID=partner-udemy&from=global-marketing-partnerships&kw=partner-udemy&sid=us_prtnr_ca_upskill_au_jkw_cr_cert-agg_pt_udemy_tm_marketing';

/**
 * Props for IndeedCta component.
 * @property background - Background color or image URL.
 * @property onReturnUrl - URL to redirect when button is clicked.
 */
export interface IndeedCtaProps {
    background?: string;
    onReturnUrl?: string;
}

export function IndeedCtaMobile({
    background = '#4338CA',
    onReturnUrl = DEFAULT_INDEED_URL,
}: IndeedCtaProps) {
    const {pageFor} = usePageContext();
    const {gettext} = useI18n();

    const handleClick = () => {
        publishEvent(new LandingPageCTASelected({componentName: 'see_jobs_at', pageFor}));
    };

    return (
        <div className={styles.indeed_cta_layout}>
            <section
                className={styles.cta}
                style={{background: typeof background === 'string' ? background : undefined}}
            >
                <div className={styles.content}>
                    <div className={styles.textSection}>
                        <div className={styles.logos}>
                            <Image
                                src="/indeed/indeed-cta/indeed-logo.svg"
                                alt="Indeed"
                                className={styles.indeed_logo}
                                width={100}
                                height={100}
                            />
                            <span className={styles.divider}>|</span>
                            <Image
                                src="/indeed/indeed-cta/udemy-logo.svg"
                                alt="Udemy"
                                className={styles.udemy_logo}
                                width={100}
                                height={100}
                            />
                        </div>
                        <h1 className={styles.title}>{gettext('Apply your skills')}</h1>
                        <Link
                            href={onReturnUrl}
                            className={styles.ctaButton}
                            role="button"
                            tabIndex={0}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={handleClick}
                        >
                            {gettext('Return to Indeed')}
                        </Link>
                        <Image
                            src="/indeed/indeed-cta/indeed-cta-mobile-background.png"
                            alt="Smiling person at computer"
                            className={styles.indeed_cta_background}
                            width={328}
                            height={291}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
